import React from "react";

import { Col, Icon } from "components";

export const SwimlaneControls = ({ items, position, handleScroll, visibleItems }) => {
  const handleIndicatorClick = (index) => {
    handleScroll(index * visibleItems);
  };

  const pages = Math.floor(items / visibleItems);
  const isActive = (index) => index * visibleItems <= position && (index + 1) * visibleItems > position;

  return (
    <>
      <Col sm={0} md={0} lg={6}>
        {items >= visibleItems * 2 && (
          <div className={"position-indicator"}>
            {" "}
            {/* don't show position indicator if there are less than 2 full "pages" */}
            {new Array(pages).fill().map((_, index) => (
              <div key={index} className={`position-indicator-rectangle ${isActive(index) ? "active" : ""}`} onClick={() => handleIndicatorClick(index)} />
            ))}
          </div>
        )}
      </Col>
      <Col sm={0} md={4} lg={2} className="arrow-container">
        {items > visibleItems && (
          <>
            <Icon
              iconName="tabler/arrow-left"
              className={`${position <= 0 ? "grey" : ""}`}
              onClick={() => position > 0 && handleScroll(position - visibleItems)}
            />
            <Icon
              iconName="tabler/arrow-right"
              className={`${position >= items - visibleItems ? "grey right" : "right"}`}
              onClick={() => position < items - visibleItems && handleScroll(position + visibleItems)}
            />
          </>
        )}
      </Col>
    </>
  );
};
